import axios from 'axios'

export default {
    findAll() {
        return axios.get('/api/modulhandbuecher')
    },
    uploadModulHandBuecher(file) {
        return axios.post('/api/modulhandbuecher/upload', {
            fileData: file
        })
    }
}
